import React, { useEffect, useState } from "react";
import { getRushNotesDetails } from "../../../services/AppointmentsAPI";
import DataTable from "../../../common/DataTable";
import { RUSH_NOTES_HEADER } from "../actions/constant";
import NotesPopUpModal from "../../Case_Management/Case_Activities/components/NotesPopUpModal";
import { formatAppointmentDateTime, formatDateTime } from "../../../utils/dateUtils";

interface GetAppointmentNotesProps {
  caseInfoID: number;
  onClose: any;
  subjectQmeScheduleID: any;
}

const GetAppointmentNotes: React.FC<GetAppointmentNotesProps> = ({
  caseInfoID,
  onClose,
  subjectQmeScheduleID,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [notesData, setNotesData] = useState<any[]>([]);
  const [notesID, setNotesID] = useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);

  const getRushNotesData = async () => {
    try {
      setLoading(true);

      const data = await getRushNotesDetails(subjectQmeScheduleID);
      const formattedData = data?.map((item: any) => ({
        ...item,
        patientName: `${item.patientName || ""} (${item.accountNo || ""}) | ${item.claimNumber || ""} | ${item.caseId || ""}`,
        createdByName: `${item.createdByName || ""}  ${formatAppointmentDateTime(item.createdDate)}`,
        isAlwaysVisible: item.visibilityStatus,
        appointmentDateTime: item.appointmentDateTime
          ? `${formatAppointmentDateTime(item.appointmentDateTime)} | ${item.examTypeDesc || ""}`
          : item.caseType || "",
      })) || [];
      setNotesData(formattedData);


    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getRushNotesData();
  }, [caseInfoID]);

  const handleOpenModal = (noteId: number) => {
    setNotesID(noteId);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setNotesID(null);
  };

  return (
    <>
      <div className="main_wrapper_section">
        <div className="mb-3">
          <DataTable
            headers={RUSH_NOTES_HEADER}
            rows={notesData}
            onRowSelect={handleOpenModal}
          />
        </div>
      </div>
      <NotesPopUpModal
        show={showModal}
        onClose={handleCloseModal}
        keyId={notesID}
      />
    </>
  );
};

export default GetAppointmentNotes;
